import React from 'react';

import {type RouteData} from '../types';
import {ENTITY_SANDBOXES_PATH} from './sandboxesPaths';

export const SANDBOXES_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Sandboxes',
    },
    exact: true,
    isPrivateRoute: true,
    path: ENTITY_SANDBOXES_PATH,
    RouteComponent: React.lazy(() => import('../../pages/EntityPage')),
  },
];
